import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';

import ReasonOptionSelector from '../reasonoptionselector/components/reasonoptionselector';

const rootDialogStyle = {
  width: '720px',
  padding: '1em'
};

const buttonContainerStyle = {
  float: 'right'
};

const AddReasonOptionDialog = ({
  isOpen,
  reasonOptions,
  encounterCmsCodeId,
  encounterId,
  performApproveRemove,
  mode,
  closeDialog
}) => {
  const [selectedReasonOptionState, setSelectedReasonOptionState] = useState([]);

  const selectReasonOption = reasonOptionId => {
    setSelectedReasonOptionState([
      ...selectedReasonOptionState,
      reasonOptionId
    ]);
  };

  const deselectReasonOption = reasonOptionId => {
    const nextState = selectedReasonOptionState.filter(x => x !== reasonOptionId);
    setSelectedReasonOptionState(nextState);
  };


  return (
    <Dialog
      open={isOpen}
      onExit={() => setSelectedReasonOptionState([])}
      maxWidth="lg"
      disableBackdropClick
      disableEscapeKeyDown
    >
      <div style={rootDialogStyle}>
        <ReasonOptionSelector
          reasonOptions={reasonOptions}
          selectReasonOption={selectReasonOption}
          deselectReasonOption={deselectReasonOption}
          selectedReasonOptions={selectedReasonOptionState}
          filterPredicate={x => x.reasonType === mode}
        />

        {/* cancel & ok buttons */}
        <div style={buttonContainerStyle}>
          <button
            onClick={closeDialog}
          >
            Cancel
          </button>

          <button
            onClick={() => {
              performApproveRemove(
                encounterId,
                encounterCmsCodeId,
                selectedReasonOptionState
              );
            }}
            disabled={selectedReasonOptionState.length < 1}
          >
            Ok
          </button>
        </div>
      </div>
    </Dialog>
  );
};

AddReasonOptionDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  reasonOptions: PropTypes.array.isRequired,
  mode: PropTypes.string.isRequired,
  closeDialog: PropTypes.func.isRequired,
  encounterCmsCodeId: PropTypes.arrayOf(PropTypes.number).isRequired,
  encounterId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  performApproveRemove: PropTypes.func.isRequired
};

export default AddReasonOptionDialog;
